module.exports = __webpack_public_path__ + "static/media/trans-ontract-issuance.2a6ffe18.svg";